import { CloseButton } from '@headlessui/react'
import { memo } from 'react'

import { AnimatedSpinner } from '../../../../components/AnimatedSpinner'
import { CloseIcon, ExpandIcon } from '../../../../components/Icons'
import type { States } from '../constants'

interface IGenerateMentorIndicatorProps {
  status: States
  openPopup: () => void
}

const GenerateMentorIndicator: React.FC<IGenerateMentorIndicatorProps> = memo(
  ({ status, openPopup }) => {
    const renderIcon = (status?: States) => {
      switch (status) {
        case 'generating':
          return (
            <div className="h-10 w-10 rounded-full bg-white m-auto flex items-center justify-center text-[#78788C] relative">
              <AnimatedSpinner />
            </div>
          )
        case 'generated':
          return (
            <div className="h-10 w-10 rounded-full bg-[#27AE60] m-auto flex items-center justify-center relative">
              <i className="fa-solid fa-check" />
            </div>
          )
        case 'error':
          return (
            <div className="h-10 w-10 rounded-full bg-[#EB5757] m-auto flex items-center justify-center relative">
              <CloseIcon />
            </div>
          )
        default:
          return (
            <div className="relative h-6 w-6 rounded-full bg-[#F2F2F4] m-auto flex items-center justify-center" />
          )
      }
    }

    const lineClassName = 'absolute bg-white h-[1px] w-[120px] top-[25px]'

    return (
      <div className="z-50 fixed bottom-[32px] right-[32px] tc-mv-blur text-white w-[316px]">
        <div className="text-lg text-white w-full flex pt-4 px-6">
          Generate companion
          <CloseButton
            onClick={openPopup}
            className="text-white ms-auto opacity-70 hover:opacity-100"
          >
            <ExpandIcon />
          </CloseButton>
        </div>

        <div className="px-6 flex justify-between items-center pb-[18px] pt-[18px]">
          <div className="flex flex-col items-center justify-between h-[70px]">
            {renderIcon(status === 'default' ? 'generating' : 'generated')}
            <div className="font-normal text-sm text-[#F2F2F4]">Define</div>
          </div>

          <div className="relative -z-10 flex flex-col items-center justify-between h-[70px]">
            <div
              className={`${lineClassName} right-5  -z-1 ${
                status === 'default' ? 'opacity-[0.12]' : ''
              }`}
            />
            <div
              className={`${lineClassName} left-5 ${
                status === 'generating' ||
                status === 'error' ||
                status === 'default'
                  ? 'opacity-[0.12]'
                  : ''
              }`}
            />
            {renderIcon(status)}
            <div className="font-normal text-sm text-[#F2F2F4]">Generate</div>
          </div>

          <div className="flex flex-col items-center justify-between h-[70px]">
            {renderIcon()}
            <div className="font-normal text-sm text-[#F2F2F4]">Done</div>
          </div>
        </div>
      </div>
    )
  },
)

export { GenerateMentorIndicator }
